<template>
    <div class="mt-3">
         
         <emc-table-items 
            :headers="headers" 
            v-bind:params.sync="params"
            v-bind:collections.sync="collections"
            v-bind:meta.sync="meta"
            v-bind:itemDelete.sync="itemDelete" 
            v-bind:itemEdit.sync="model"
            :find="false"
            :loadingText="loadingText"
        />

        <sys-register-activity-item @onCompleted="getData()" :teacher="teacher" :model="model" v-bind:show.sync="showForm" />

    <!-- Modal usado para mensagem e ação de exclusão -->
        <emc-alert-modal :text="textDelete" :disabled="deleting" v-bind:show.sync="show">
            <template v-slot:actions>
                <v-btn color="error" @click.prevent.stop="deleteItem()" :loading="deleting" :disabled="deleting">Excluir <v-icon right dark>mdi-delete</v-icon></v-btn>
            </template>
        </emc-alert-modal>
        
        <!-- Alert para mensagens -->
        <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
    
    </div>

</template>
<script>

import { mapActions } from 'vuex'

export default {
   name: 'SysTeacherActivity',
   data: () => ({
    collections: [],
    loadingText: '',
    params: {},
    message: '',
    error: false,
    errors: {},
    loading: false,
    meta: {},
    itemDelete: {},
    model: {},
    itemUpdate: {},
    show: false,
    showForm: false,
    text: 'Carregando dados...',
    textDelete: '',
    deleting: false,
    
    headers: [
        { text: 'Campus', value: 'activity_item.campus.name'},
        { text: 'Atividade', value: 'activity_item.activity.name'},
        { text: 'Periodicidade', value: 'activity_item.periodicity_type.name'},
        { text: 'Tipo', value: 'activity_item.value_type.name'},
        { text: 'Valor', value: 'value', align: 'center'},
        { text: 'Compõe CH', value: 'is_work_load', type: 'boolean', align: 'center'},
        { text: 'Período', value: ['start', 'end'], range: true, type: 'date', align: 'center'},
        // { text: 'Ações', value: 'actions'},
    ]
    }),

    props: {
        teacher: {
            type: Object,
            required: true
        },
        
        showAdd: {
            type: Boolean,
            default: false
        }
    },

    watch: {
      
      //Função para tratar quando um item for exibido para deletar
      itemDelete(item_new, item_old){
          
          if(item_new !== item_old && Object.keys(item_new).length > 0)
          {
              this.show = true;
              this.textDelete = "Deseja excluir o item?";
          } else {
              this.show = false
              this.textDelete = '';
          }
      },
      
      showAdd(val){
          if(val){
            this.model = {};
            this.showForm = true;
          }
          
      },

      showForm(val){
          if(!val){
                this.$emit('update:showAdd', val);
          }
      },

      model(item_new, item_old){
          
        if(item_new !== item_old && this.teacher.id)
          {
              this.showForm = true;
              this.errors = {};
          } else if(Object.keys(this.model).length === 0){
              this.showForm = false;
              this.errors = {};
          }           
      },

    },
    components: {
      
    },
    mounted(){
       
    },
    created() {
       if(this.teacher && this.teacher.id){
        this.getData();
       }
       
    },
    methods: {
      ...mapActions('activityItem', ['ActionIndexActivityItemTeachers', 'ActionDeleteActivityItemTeacher']),
        
    getData(){
        
        this.error = false;
        this.message = '';
        this.showForm = false;
        this.loadingText = 'Carregando dados...';
        this.collections = [];
        
        this.params.with = 'activityItem.teacher,activityItem.campus,activityItem.courses,activityItem.activity,activityItem.valueType,activityItem.periodicityType,teacher.campuses,timeTables';
        this.params.find_columns = {
            teacher_id: this.teacher.id,
        };
            

        this.ActionIndexActivityItemTeachers(this.params)
            .then((res) => {
                

                let items = [];

                res.data.forEach(item => {
                    if(item.activity_item.activity_item_status_id != 4 && item.activity_item.activity_item_status_id != 6){
                        items.push(item);
                    }
                });

                this.collections = items;

                this.meta = res.meta;
            })
            .finally(() => {
                this.loadingText = '';
            });
    },

    deleteItem()
        {
            this.deleting = true;
            this.message = '';

            this.ActionDeleteActivityItemTeacher({id: this.itemDelete.id})
                .then((res) => {
                    this.message = res.message;
                    this.show = false;
                    this.getData(res.data);
                })
                .catch((error) =>{
                  this.message = error.message;
                  this.error = true;
                })
                .finally(() => {
                    this.deleting = false;
                });
        }

  },

}
</script>
